import { render, staticRenderFns } from "./myFeedbackList.vue?vue&type=template&id=44a17697&scoped=true"
import script from "./myFeedbackList.vue?vue&type=script&lang=js"
export * from "./myFeedbackList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a17697",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44a17697')) {
      api.createRecord('44a17697', component.options)
    } else {
      api.reload('44a17697', component.options)
    }
    module.hot.accept("./myFeedbackList.vue?vue&type=template&id=44a17697&scoped=true", function () {
      api.rerender('44a17697', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/downLoadCenter/myFeedbackList.vue"
export default component.exports